/* SLIDE 1 */
/* SLIDE 2 */
/* SLIDE 3 */

import React, { useState, useEffect } from "react";
import Popup from "shared/components/Popup";
import logo from "assets/images/logo.svg";
import logo2 from "assets/images/logo2.svg";
import accIcon from "assets/icons/accIcon.svg";
import pwIcon from "assets/icons/pwIcon.svg";
import noteIcon from "assets/icons/noteIcon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginThunk } from "features/auth/presentation/store/authSlice";
import { useForm } from "react-hook-form";
import { setAppLoading } from "../../../shared/store/headerSlice";
import { DateTime } from "luxon";
import { getUserWorkingTime } from "features/user/usecases/UserUsecases";
import { setLogedIn, setPasPort, setToken } from "./store/authSlice";
import AppSelect from "../../../shared/components/AppSelect";
import api, { getApiBaseUrl } from "../../../helpers/api";
import { STORAGE_KEYS } from "../../../hooks/useAttendanceCheck";

const LoginPage = () => {
  const user = useSelector((state) => state.auth.user);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { pasPort, logedIn } = useSelector((state) => state.auth);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupLogined, setShowPopupLogined] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [showPopupWrongParkingLot, setShowPopupWrongParkingLot] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("user", user);
    if (user?.userId) {
      navigate("/menu_manager", { replace: true });
    }
  }, []);

  useEffect(() => {
    if (pasPort) {
      setTimeout(() => {
        api.defaults.baseURL = getApiBaseUrl();
      }, 0);
    }
  }, [pasPort]);

  const onError = (errors) => {
    if (errors.id || errors.password) {
      setErrorPopup(true);
    } else {
      setErrorPopup(false);
    }
  };

  const handleLogin = async (data) => {
    dispatch(setAppLoading(true));
    const resultAction = await dispatch(loginThunk({
      id: data.id?.trim(),
      password: data.password?.trim(),
    }));

    if (loginThunk.fulfilled.match(resultAction)) {
      const payload = resultAction?.payload;
      const response = await getUserWorkingTime({
        userId: payload?.userId,
        parkingId: payload?.parking?.parkingId,
      });

      const data = response?.data;
      const accessToken = payload?.accessToken;
      const refreshToken = payload?.refreshToken;
      if (accessToken && refreshToken) {

        dispatch(setToken({ accessToken: accessToken, refreshToken: refreshToken }));
      }

      if (data?.attendanceDate) {
        const savedCheckinTime = DateTime.fromFormat(data?.attendanceDate, "yyyyMMddHHmmss", { setZone: true }).toFormat("yyyy-MM-dd HH:mm:ss");
        const savedNote = data?.attendanceNote || "";

        localStorage.setItem(STORAGE_KEYS.CHECKIN_TIME, savedCheckinTime);
        localStorage.setItem(STORAGE_KEYS.ATTENDANCE_NOTE, savedNote);

      } else {
        localStorage.removeItem(STORAGE_KEYS.CHECKIN_TIME);
        localStorage.removeItem(STORAGE_KEYS.ATTENDANCE_NOTE);
      }
      if (data?.leaveWorkDate) {
        const savedCheckoutTime = DateTime.fromFormat(data?.leaveWorkDate, "yyyyMMddHHmmss", { setZone: true }).toFormat("yyyy-MM-dd HH:mm:ss");
        const leaveNote = data?.leaveWorkNote || "";

        localStorage.setItem(STORAGE_KEYS.CHECKOUT_TIME, savedCheckoutTime);
        localStorage.setItem(STORAGE_KEYS.LEAVE_WORK_NOTE, leaveNote);

      } else {
        localStorage.removeItem(STORAGE_KEYS.CHECKOUT_TIME);
        localStorage.removeItem(STORAGE_KEYS.LEAVE_WORK_NOTE);
      }

      const checkinTime = localStorage.getItem(STORAGE_KEYS.CHECKIN_TIME);
      setTimeout(() => {
        dispatch(setLogedIn(!logedIn));

      }, 1000);
      if (checkinTime) {
        dispatch(setAppLoading(false));
        navigate("/menu_manager", { replace: true });
      } else {
        dispatch(setAppLoading(false));
        console.log("data", data);
        navigate("/time_attendance", {
          replace: true,
          state: {
            from: "login",
            latestMemo: data?.latestMemo || "",
          }
        });
      }
    } else if (loginThunk.rejected.match(resultAction)) {
      const payload = resultAction?.payload;
      console.log(payload);
      if (payload == "FAIL") {
        dispatch(setAppLoading(false));
        setShowPopup(true);
      } else if (payload == "PARKING_LOT_MISMATCH") {
        dispatch(setAppLoading(false));
        setShowPopupWrongParkingLot(true);
      } else {
        dispatch(setAppLoading(false));
        setShowPopupLogined(true);
      }

    }
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleCloseLogined = () => {
    setShowPopupLogined(false);
  };

  return (
    <>
      <div className="login-container mn-login-container">
        <div className="login-title">
          <img src={logo} alt="logo" />
        </div>

        <form onSubmit={handleSubmit(handleLogin, onError)} className="login-form">
          <div className="login-form-input mn-login-form-input">
            <img src={accIcon} alt="accIcon" />
            <input type="text" autoCapitalize="none" placeholder="근무자 (시스템아이디)" {...register("id", { required: true })} />
          </div>

          <div className="login-form-input mn-login-form-input">
            <img src={pwIcon} alt="pwIcon" />
            <input type="password" placeholder="비밀번호" {...register("password", { required: true })} />
          </div>
          <AppSelect
            className="htSection mb-0 pt-0 pb-0"
            style={{ height: 50 }}
            value={pasPort}
            onChange={(e) => {
              dispatch(setPasPort(e.target.value));
            }}
            options={[
              {
                label: "방이습지: 8021",
                value: 8021,
              },
              {
                label: "비석거리: 8022",
                value: 8022,
              },
              {
                label: "방이고분: 8023",
                value: 8023,
              },
              {
                label: "석촌고분: 8024",
                value: 8024,
              },
            ]}
          />
          <button className="login-button" type="submit">
            로그인
          </button>
        </form>

        <div className="login-footer text-gray-400">
          <img src={noteIcon} alt="noteIcon" />
          <span>
            로그인 및 이용관련 문의사항이 있으실 경우 <span className="text-black">시스템관리자</span>에게 문의해주시기 바랍니다.
          </span>

          <br />
        </div>
        <div className="login-title mn-login-logo ">
          <img src={logo2} alt="logo" />
        </div>
      </div>
      {showPopup && (
        <Popup
          title="ID/PW 확인"
          handleYes={handleClose}
          textYes="닫기"
          setVisible={setShowPopup}
        >
          <p>ID, 비밀번호를 확인해주세요</p>
        </Popup>
      )}
      {showPopupLogined && (
        <Popup
          title="알림"
          handleYes={handleCloseLogined}
          textYes="닫기"
          setVisible={setShowPopupLogined}
        >
          <p>이미 로그인된 사용자가 있습니다.</p>
        </Popup>
      )}
      {showPopupWrongParkingLot && (
        <Popup
          title="알림"
          handleYes={() => setShowPopupWrongParkingLot(false)}
          textYes="닫기"
          setVisible={setShowPopupWrongParkingLot}
        >
          <p className="px-10">고객님의 계정은 다른 주차장에 등록되어 있습니다.</p>
        </Popup>
      )}
      {errorPopup && (
        <Popup
          title="ID/PW 확인"
          handleYes={() => setErrorPopup(false)}
          textYes="닫기"
          setVisible={setErrorPopup}
        >
          <p>계정과 비밀번호를 모두 입력해 주세요.</p>
        </Popup>
      )}
    </>
  );
};

export default LoginPage;
